import React from "react";
import { Row, Col, Card, Statistic, Typography, Skeleton } from "antd";
import { Title } from "components/common";
import styles from "./DashboardKPIs.module.less";

const { Text } = Typography;

const KpiSkeleton = () => (
  <Card className={styles.sectionCard}>
    <div className={styles.sectionHeader}>
      <Skeleton.Input active size="small" className={styles.skeletonTitle} />
    </div>
    <Row gutter={[16, 16]} className={styles.kpiRow}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Col key={i} xs={24} sm={12} md={8} lg={8} xl={8}>
          <Card className={styles.kpiCard} bordered>
            <Skeleton.Input active size="small" className={styles.skeletonKpiLabel} />
            {/* <Skeleton.Input active block className={styles.skeletonKpiValue} /> */}
            <Skeleton.Input active size="small" className={styles.skeletonKpiDesc} />
          </Card>
        </Col>
      ))}
    </Row>
  </Card>
);

const DashboardKPIs = ({ stats, loading, isFetching }) => {
  if (loading) return <KpiSkeleton />;

  return (
    <Card className={styles.sectionCard}>
      <div className={styles.cardContentWrap}>
        <div className={styles.sectionHeader}>
          <Title level={5} className={styles.sectionTitle}>
            Key Performance Metrics
          </Title>
        </div>
        <Row gutter={[16, 16]} className={styles.kpiRow}>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Card className={styles.kpiCard} bordered>
            <Statistic
              title="TOTAL QUIZZES ATTEMPTED"
              value={stats?.totalQuizzes ?? "—"}
              valueStyle={{ fontSize: "1.5rem", fontWeight: 600 }}
            />
            <Text type="secondary" className={styles.kpiDesc}>
              All-time count
            </Text>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Card className={styles.kpiCard} bordered>
            <Statistic
              title="OVERALL ACCURACY"
              value={
                stats?.overallAccuracy != null
                  ? `${stats.overallAccuracy}%`
                  : "—"
              }
              valueStyle={{ fontSize: "1.5rem", fontWeight: 600 }}
            />
            <Text type="secondary" className={styles.kpiDesc}>
              Correct / Total
            </Text>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Card className={styles.kpiCard} bordered>
            <Statistic
              title="AVERAGE SCORE"
              value={stats?.averageScore ?? "—"}
              valueStyle={{ fontSize: "1.5rem", fontWeight: 600 }}
            />
            <Text type="secondary" className={styles.kpiDesc}>
              Points per quiz
            </Text>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Card className={styles.kpiCard} bordered>
            <Statistic
              title="STRONGEST SPECIALTY"
              value={stats?.strongestSpeciality ?? "—"}
              valueStyle={{ fontSize: "1.25rem", fontWeight: 600 }}
            />
            <Text type="secondary" className={styles.kpiDesc}>
              Highest accuracy
            </Text>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Card className={styles.kpiCard} bordered>
            <Statistic
              title="WEAKEST SPECIALTY"
              value={stats?.weakestSpeciality ?? "—"}
              valueStyle={{ fontSize: "1.25rem", fontWeight: 600 }}
            />
            <Text type="secondary" className={styles.kpiDesc}>
              Lowest accuracy
            </Text>
          </Card>
        </Col>
      </Row>
        {isFetching && <div className={styles.shimmerOverlay} />}
      </div>
    </Card>
  );
};

export default DashboardKPIs;
